import React from "react";
import { Phone, Clock, MapPin, Facebook, Instagram } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B2542] text-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-32 -right-24 h-[360px] w-[360px] rounded-full opacity-25"
        style={{
          background:
            "radial-gradient(circle, rgba(0,180,216,0.6), rgba(0,180,216,0) 60%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="h-16 w-16 flex items-center justify-center">
              <img
                src={SITE.footerLogoUrl}
                alt="Vision Glass Care"
                className="h-16 w-16 object-contain"
              />
            </span>
            <div>
              <div className="font-[Outfit] font-bold text-xl">{SITE.name}</div>
              <div className="text-xs uppercase tracking-[0.18em] text-[#90E0EF]">
                {SITE.city}
              </div>
            </div>
          </div>
          <p className="mt-5 text-white/75 max-w-md leading-relaxed">
            Locally-owned residential and commercial window cleaning. Streak-free,
            detail-obsessed, and backed by a 100% satisfaction guarantee.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <a
              href={SITE.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 ring-1 ring-white/15 flex items-center justify-center transition-colors"
              aria-label="Vision Glass Care on Facebook"
            >
              <Facebook className="h-5 w-5 text-white" />
            </a>
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 ring-1 ring-white/15 flex items-center justify-center transition-colors"
              aria-label="Vision Glass Care on Instagram"
            >
              <Instagram className="h-5 w-5 text-white" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-[#90E0EF] font-bold">
            Get in touch
          </div>
          <ul className="mt-5 space-y-3 text-white/85">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#90E0EF]" />
              <a
                href={`tel:${SITE.phoneTel}`}
                className="hover:text-white"
                data-testid="footer-phone"
              >
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-[#90E0EF]" />
              {SITE.hours}
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-1 text-[#90E0EF]" />
              <span>Baton Rouge, Denham Springs, Shenandoah, Walker, Watson & surrounding</span>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-[#90E0EF] font-bold">
            Explore
          </div>
          <ul className="mt-5 grid grid-cols-2 gap-y-3 gap-x-4 text-white/85">
            <li>
              <a href="#services" className="hover:text-white" data-testid="footer-link-services">
                Services
              </a>
            </li>
            <li>
              <a href="#default-service" className="hover:text-white" data-testid="footer-link-default">
                Standard package
              </a>
            </li>
            <li>
              <a href="#gallery" className="hover:text-white" data-testid="footer-link-gallery">
                Our work
              </a>
            </li>
            <li>
              <a href="#areas" className="hover:text-white" data-testid="footer-link-areas">
                Service areas
              </a>
            </li>
            <li>
              <a href="#faq" className="hover:text-white" data-testid="footer-link-faq">
                FAQ
              </a>
            </li>
            <li>
              <a href="#testimonials" className="hover:text-white" data-testid="footer-link-testimonials">
                Reviews
              </a>
            </li>
            <li>
              <a href="#quote" className="hover:text-white" data-testid="footer-link-quote">
                Get a quote
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/60">
          <div>© {year} Vision Glass Care. All rights reserved.</div>
          <div>Streak-free guaranteed · Locally owned in Baton Rouge, LA</div>
        </div>
      </div>
    </footer>
  );
}
